import React from 'react';
import { BaseCustomButton } from '../../shared/components/base-custom-button/BaseCustomButton';

export const AnalysisRequestNewRegisterButton = ({ setShowModal, text, disabled = false, icon = ''}) => {
    return (
        <BaseCustomButton
            color="primary"
            disabled={disabled}
            onClick={() => setShowModal(true)}
            icon={icon === 'attendRequest' ? 'mdi-18px mdi-checkbox-marked-circle' : 'mdi-18px mdi-plus'}
            label={text}
            className="ms-2"
        />
    );
};
